var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12 col-md-8 mx-auto mt-4"},[_c('h1',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$t('utenza_disabilitata')))]),_c('div',{staticClass:"col-lg-4 col-sm-7 mx-auto my-3 pb-4"},[_c('span',{staticClass:"text-secondary fs-6"},[_vm._v(" "+_vm._s(_vm.$t('messaggio_utenza_disabilitata'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }